exports = module.exports = require("../../../../../../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".Qky1O6F1S0DeG2NXHLUmP{max-width:600px!important}html[dir] ._1sTKbzSYIfQgtmQfVcFhIE{margin-top:20px}._1l4GvjMpJiduZ6exEU6YyT{display:inline-block}", ""]);

// exports
exports.locals = {
	"dialog": "Qky1O6F1S0DeG2NXHLUmP",
	"marginTop": "_1sTKbzSYIfQgtmQfVcFhIE",
	"spinner": "_1l4GvjMpJiduZ6exEU6YyT"
};